import React from 'react';
import Layout from '../../components/Layout';
import Contact from './Contact';
import { getConfigData } from '../../helpers/getConfigData';
import messages from '../../locale/jsonMessages';

export default async function action({ intl }) {

  const title = intl?.formatMessage(messages.contactForm);

  const reCaptcha = await getConfigData({ name: ['reCaptchaStatus'] });

  return {
    title,
    component: <Layout><Contact title={title} reCaptcha={reCaptcha} /></Layout>,
  };
};
